import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ScheduleProvider } from './contexts/ScheduleContext';
import { checkDatabaseSetup } from './utils/setupDatabase';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Register from './pages/Register';
import Login from './pages/Login';
import Events from './pages/Events';
import Schedule from './pages/Schedule';
import DashboardSwitch from './pages/DashboardSwitch';
import ResetPassword from './pages/ResetPassword';
import AttendeesDirectory from './pages/AttendeesDirectory';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import AdminDashboard from './pages/AdminDashboard';
import AdminEventManagement from './pages/AdminEventManagement';
import AdminUserManagement from './pages/AdminUserManagement';


function App() {
  useEffect(() => {
    // Check database setup on app start
    checkDatabaseSetup();
  }, []);

  return (
    <AuthProvider>
      <ScheduleProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Navbar />
            <main className="container mx-auto px-4 py-8">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/register" element={<Register />} />
                <Route path="/login" element={<Login />} />
                <Route path="/events" element={<Events />} />
                <Route 
                  path="/schedule" 
                  element={
                    <ProtectedRoute>
                      <Schedule />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/dashboard" 
                  element={
                    <ProtectedRoute>
                      <DashboardSwitch />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/dashboard" 
                  element={
                    <AdminRoute>
                      <AdminDashboard />
                    </AdminRoute>
                  }
                />
                <Route 
                  path="/admin/users" 
                  element={
                    <AdminRoute>
                      <AdminUserManagement />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/admin/events"
                  element={
                    <AdminRoute>
                      <AdminEventManagement />
                    </AdminRoute>
                  }
                />
                <Route
                path="/attendees"
                element={
                  <ProtectedRoute>
                    <AttendeesDirectory />
                  </ProtectedRoute>
                  }
                />
                <Route path="/reset-password" element={<ResetPassword />} />

              </Routes>
            </main>
          </div>
        </Router>
      </ScheduleProvider>
    </AuthProvider>
  );
}

export default App;